(() => {
  const pageSize = 5;

  document.querySelectorAll('.reviews_data_wrap').forEach((reviewSection) => {
    const reviewList = reviewSection.querySelector('.reviews_data_list');
    const reviewContainer = reviewSection.querySelector('.reviews_data');
    if (!reviewList || !reviewContainer || reviewSection.dataset.paginationReady === 'true') return;

    const reviewCapacity = getReviewCapacity(reviewSection);
    const reviews = [...reviewList.querySelectorAll(':scope > .reviews_data_item')].slice(0, reviewCapacity);
    const pageCount = Math.ceil(reviews.length / pageSize);
    if (pageCount <= 1) return;

    reviewSection.dataset.paginationReady = 'true';
    reviewSection.dataset.pageSize = String(pageSize);
    reviewSection.dataset.reviewCapacity = String(reviewCapacity);

    reviewContainer.querySelectorAll(':scope > a[href="javascript:void(0);"]').forEach((legacyControl) => {
      legacyControl.hidden = true;
      legacyControl.setAttribute('aria-hidden', 'true');
    });

    const pagination = document.createElement('nav');
    pagination.className = 'product-review-pagination';
    pagination.setAttribute('aria-label', 'Customer review pages');

    const previousButton = createButton('Previous', '‹');
    previousButton.dataset.action = 'previous';
    const nextButton = createButton('Next', '›');
    nextButton.dataset.action = 'next';
    const pageButtons = Array.from({ length: pageCount }, (_, index) => {
      const button = createButton(`Page ${index + 1}`, String(index + 1));
      button.dataset.page = String(index);
      return button;
    });

    pagination.append(previousButton, ...pageButtons, nextButton);
    reviewContainer.append(pagination);

    renderReviewPage(reviewSection, 0);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-review-pagination__button');
    if (!button) return;

    const reviewSection = button.closest('.reviews_data_wrap');
    if (!reviewSection) return;

    const activePage = Number(
      reviewSection.querySelector('.product-review-pagination__button[aria-current="page"]')?.dataset.page || 0
    );
    let requestedPage = activePage;

    if (button.dataset.page) requestedPage = Number(button.dataset.page);
    if (button.dataset.action === 'previous') requestedPage = activePage - 1;
    if (button.dataset.action === 'next') requestedPage = activePage + 1;

    renderReviewPage(reviewSection, requestedPage);
  }, true);

  function renderReviewPage(reviewSection, page) {
    const reviewCapacity = getReviewCapacity(reviewSection);
    const reviews = [...reviewSection.querySelectorAll('.reviews_data_item')].slice(0, reviewCapacity);
    const pageButtons = [...reviewSection.querySelectorAll('.product-review-pagination__button[data-page]')];
    const previousButton = reviewSection.querySelector('[data-action="previous"]');
    const nextButton = reviewSection.querySelector('[data-action="next"]');
    const pageCount = Math.ceil(reviews.length / pageSize);
    const currentPage = Math.min(Math.max(page, 0), pageCount - 1);
    const start = currentPage * pageSize;
    const end = start + pageSize;

    reviews.forEach((review, index) => {
      review.hidden = index < start || index >= end;
    });

    pageButtons.forEach((button, index) => {
      if (index === currentPage) {
        button.setAttribute('aria-current', 'page');
      } else {
        button.removeAttribute('aria-current');
      }
    });

    previousButton.disabled = currentPage === 0;
    nextButton.disabled = currentPage === pageCount - 1;
  }

  function getReviewCapacity(reviewSection) {
    const configuredCapacity = Number(
      reviewSection.previousElementSibling?.dataset.reviewCapacity
    );
    return Number.isFinite(configuredCapacity) && configuredCapacity > 0 ? configuredCapacity : 20;
  }

  function createButton(label, text) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-review-pagination__button';
    button.setAttribute('aria-label', label);
    button.textContent = text;
    return button;
  }
})();
